import styled from "styled-components";

export default styled.div`
  padding: 10px;
  box-sizing: border-box;
`;
